import { useQuery } from '@tanstack/react-query'

import { BrandKitsAPI } from '@makyoapp/makyo-sdk'
import { Order } from '@makyoapp/makyo-sdk/api/api'
import { BrandKitsOrderBy } from '@makyoapp/makyo-sdk/models/BrandKits'

import { fromSdkBrandKit, fromSdkBrandKitPresenterList } from '@/adapters/__project__/BrandKitAdapter'
import { queryKeys } from '@/lib/react-query'
import { useCurrentOrgContext } from '@/context/CurrentOrgContext'

/**
 * Get Org's Brand Kit List
 */
export const useGetBrandKits = () => {
  const { currentOrg } = useCurrentOrgContext()
  const orgID = currentOrg?.id

  return useQuery({
    queryKey: [queryKeys.orgBrandKits, orgID],
    queryFn: () => {
      if (!orgID) return
      return BrandKitsAPI.ReqList(orgID, undefined, Order.Desc, BrandKitsOrderBy.CreatedAt).then(
        fromSdkBrandKitPresenterList
      )
    },
    enabled: !!orgID,
  })
}

/**
 * Get Brand Kit detail
 */
export const useGetBrandKitDetail = (brandId?: string) => {
  return useQuery({
    queryKey: [queryKeys.orgBrandKitDetail, brandId],
    queryFn: () => {
      if (!brandId) return
      return BrandKitsAPI.ReqGet(brandId).then(fromSdkBrandKit)
    },
    enabled: !!brandId,
  })
}
